{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "wealthlane://modules/espp",
  "title": "ESPP Offering Period",
  "description": "Employee stock purchase plan offering period — flat API DTO field catalog.",
  "type": "object",
  "properties": {
    "offeringPeriodId": {
      "type": "string",
      "title": "Offering Period ID",
      "widget": "hidden"
    },
    "planId": {
      "type": "string",
      "title": "Plan Name",
      "format": "uuid",
      "widget": "select"
    },
    "name": {
      "type": "string",
      "title": "Name",
      "maxLength": 200,
      "noBlank": true
    },
    "offeringPeriodStartDate": {
      "type": "string",
      "title": "Start Date",
      "format": "date"
    },
    "offeringPeriodEndDate": {
      "type": "string",
      "title": "End Date",
      "format": "date"
    },
    "fmvAtStart": {
      "type": "number",
      "title": "FMV at Grant ($)",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "currency"
    },
    "offeringPeriodType": {
      "type": "string",
      "title": "Offering Period Type",
      "widget": "select",
      "options": [
        { "label": "Qualified", "value": "Qualified" },
        { "label": "NonQualified", "value": "NonQualified" }
      ]
    },
    "discountPercent": {
      "type": "number",
      "title": "Discount %",
      "minimum": 0,
      "inputPrecision": 2,
      "displayPrecision": 2,
      "displayFormat": "percentage"
    },
    "lookback": {
      "type": "boolean",
      "title": "Lookback"
    },
    "description": {
      "type": "string",
      "title": "Lookback Description"
    },
    "enrollmentWindowMaxChanges": {
      "type": "integer",
      "title": "Max # of changes",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "enrollStartDaysPriorToPurchasePeriod": {
      "type": "integer",
      "title": "Days Before Period Start",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "enrollDays": {
      "type": "integer",
      "title": "Number of Days",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "changeWindowMaxUpChanges": {
      "type": "integer",
      "title": "Max # of Up Changes",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "changeWindowMaxDownChanges": {
      "type": "integer",
      "title": "Max # of Down Changes",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "changeEndDaysPriorToPurchaseDate": {
      "type": "integer",
      "title": "End # of Days Before Purchase Date",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number"
    },
    "allowParticipantToSuspendWithPurchase": {
      "type": "boolean",
      "title": "With Purchase"
    },
    "allowParticipantToSuspendWithoutPurchase": {
      "type": "boolean",
      "title": "Without Purchase"
    },
    "allowParticipantToWithdrawWithPurchase": {
      "type": "boolean",
      "title": "With Purchase"
    },
    "allowParticipantToWithdrawWithoutPurchase": {
      "type": "boolean",
      "title": "Without Purchase"
    },
    "rolloverEnrollment": {
      "type": "boolean",
      "title": "Auto Enroll"
    },
    "nextOfferingPeriodId": {
      "type": "string",
      "title": "Next Offering Period (Optional)",
      "widget": "select"
    },
    "residualCashDisposition": {
      "type": "string",
      "title": "Residual Cash Disposition",
      "widget": "select",
      "options": [
        { "label": "Rollover", "value": "Rollover" },
        { "label": "Refund", "value": "Refund" }
      ]
    },
    "purchasePeriods": {
      "type": "array",
      "title": "Purchase Periods",
      "items": {
        "$ref": "module://purchase-period"
      }
    }
  }
}
